// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetUploadDocumentRequestModel from '../../model/widget-upload-document-request-model';
import WidgetUploadDocumentRequestDTO from '../dto/widget-upload-document-request-dto';
import dtoSchema from '../schemas/widget-upload-document-request-schema';

export default abstract class WidgetUploadDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetUploadDocumentRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
      this.id = data.id;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<WidgetUploadDocumentRequestDTO>): WidgetUploadDocumentRequestModel;
  static toModel(dto: DeepPartial<WidgetUploadDocumentRequestDTO> | undefined | null): WidgetUploadDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<WidgetUploadDocumentRequestDTO> | undefined | null): WidgetUploadDocumentRequestModel | undefined {
    return dto ? new WidgetUploadDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetUploadDocumentRequestModel> | WidgetUploadDocumentRequestModel): WidgetUploadDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
      id: unwrapped.id,
    } as WidgetUploadDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetUploadDocumentRequestModel, can not map to WidgetUploadDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
